import {
    createBrowserRouter,
    RouterProvider
} from "react-router-dom";


import '@mantine/core/styles.css';
import '@flexinet/ui-components/style.css'

import {MantineProvider} from "@mantine/core";

import {theme} from "./theme.ts";

import {routesConfig} from "./config/routes.tsx";


const router = createBrowserRouter(routesConfig)

export const App = () => {
    return (
        <MantineProvider theme={theme}>
            <RouterProvider router={router}/>
        </MantineProvider>
    )
}
